@if (!inline) {
<h2 id="recommendation-header" class="mb-4 mt-lg-5">{{ 'si_pts_chrome_recommendation_tile_header' | cmsText | async }}</h2>
}

<div class="p-3 bg-light rounded-1 row justify-content-center align-items-center mx-0 mb-2">
    <div class="px-1 py-3 col-12 col-xxl-6 justify-content-center align-items-center d-flex order-xxl-last" [ngClass]="{ 'placeholder': !topRecommendation }">
        <img [src]="image" [alt]="topRecommendation.recommendation?.img_alt ?? ''" width="250">
    </div>
    <div class="col-12 col-xxl-6">
        <h2 [ngClass]="{ 'placeholder': !topRecommendation }">{{ topRecommendation.recommendation?.header }}</h2>
        <p [appParagraph]="2" [ngClass]="{ 'placeholder': !topRecommendation }">{{topRecommendation.recommendation?.text}} </p>

        <div class="d-grid gap-2 col-12 mx-auto my-2">
            <app-smart-link [recommendation]="topRecommendation.recommendation"></app-smart-link>
        </div>

    </div>

</div>
